module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_blonde.5e6d80da.png";